import { render, staticRenderFns } from "./OrgStaffClientContact.vue?vue&type=template&id=737c5cb2&scoped=true&"
import script from "./OrgStaffClientContact.vue?vue&type=script&lang=js&"
export * from "./OrgStaffClientContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737c5cb2",
  null
  
)

export default component.exports